// Theme specific JavaScript

// Quantity selectors
document.addEventListener('DOMContentLoaded', function() {
  const quantityInputs = document.querySelectorAll('.quantity-input');
  
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      if (this.value < 0) {
        this.value = 0;
      }
    });
  });
});

// Product image gallery
document.addEventListener('DOMContentLoaded', function() {
  const mediaItems = document.querySelectorAll('.product__media-item');
  
  if (mediaItems.length > 1) {
    mediaItems.forEach((item, index) => {
      item.addEventListener('click', function() {
        mediaItems.forEach(i => i.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }
});

// Accordion functionality
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.product__accordion');
  
  accordions.forEach(accordion => {
    accordion.addEventListener('toggle', function() {
      if (this.open) {
        // Close other accordions
        accordions.forEach(other => {
          if (other !== this && other.open) {
            other.open = false;
          }
        });
      }
    });
  });
});

// Smooth scroll for anchor links
document.addEventListener('DOMContentLoaded', function() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      
      if (href === '#') return;
      
      const target = document.querySelector(href);
      
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});

// Newsletter form handling
document.addEventListener('DOMContentLoaded', function() {
  const newsletterForms = document.querySelectorAll('.newsletter__form');
  
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const email = form.querySelector('input[type="email"]').value;
      
      if (!email) {
        alert('Please enter a valid email address');
        return;
      }
      
      // Submit to Shopify newsletter
      fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `contact[email]=${encodeURIComponent(email)}&form_type=customer`
      })
      .then(response => {
        if (response.ok) {
          alert('Thank you for subscribing!');
          form.reset();
        } else {
          alert('Something went wrong. Please try again.');
        }
      })
      .catch(error => {
        console.error('Newsletter error:', error);
        alert('Something went wrong. Please try again.');
      });
    });
  });
});

// Predictive search
let searchTimeout;
const searchInput = document.querySelector('.search-modal__input');

if (searchInput) {
  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimeout);
    
    const query = this.value;
    
    if (query.length < 2) return;
    
    searchTimeout = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
        .then(response => response.json())
        .then(data => {
          displaySearchResults(data);
        })
        .catch(error => {
          console.error('Search error:', error);
        });
    }, 300);
  });
}

function displaySearchResults(data) {
  const resultsContainer = document.querySelector('.search-results');
  
  if (!resultsContainer) return;
  
  if (data.resources.results.products.length === 0) {
    resultsContainer.innerHTML = '<p>No results found</p>';
    return;
  }
  
  let html = '<div class="search-results-grid">';
  
  data.resources.results.products.forEach(product => {
    html += `
      <a href="${product.url}" class="search-result-item">
        <img src="${product.featured_image}" alt="${product.title}">
        <div class="search-result-info">
          <h4>${product.title}</h4>
          <p>${product.price}</p>
        </div>
      </a>
    `;
  });
  
  html += '</div>';
  resultsContainer.innerHTML = html;
}

// Sticky header
let lastScroll = 0;
const header = document.querySelector('.header');

if (header) {
  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll <= 0) {
      header.classList.remove('scroll-up');
      return;
    }
    
    if (currentScroll > lastScroll && !header.classList.contains('scroll-down')) {
      // Scroll down
      header.classList.remove('scroll-up');
      header.classList.add('scroll-down');
    } else if (currentScroll < lastScroll && header.classList.contains('scroll-down')) {
      // Scroll up
      header.classList.remove('scroll-down');
      header.classList.add('scroll-up');
    }
    
    lastScroll = currentScroll;
  });
}

// Currency/Country selector
document.addEventListener('DOMContentLoaded', function() {
  const currencySelector = document.getElementById('currency-selector');
  
  if (currencySelector) {
    currencySelector.addEventListener('change', function() {
      const currency = this.value;
      window.location.href = `?currency=${currency}`;
    });
  }
});

// Product recommendations
async function loadProductRecommendations(productId) {
  try {
    const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=4`);
    const data = await response.json();
    
    if (data.products && data.products.length > 0) {
      displayRecommendations(data.products);
    }
  } catch (error) {
    console.error('Error loading recommendations:', error);
  }
}

function displayRecommendations(products) {
  const container = document.querySelector('.product__recommendations .product-grid');
  
  if (!container) return;
  
  container.innerHTML = products.map(product => `
    <div class="product-card">
      <a href="${product.url}">
        <img src="${product.featured_image}" alt="${product.title}">
        <h3>${product.title}</h3>
        <p>${product.price}</p>
      </a>
    </div>
  `).join('');
}

// Initialize product recommendations if on product page
if (document.querySelector('.template-product')) {
  const productId = document.querySelector('[data-product-id]')?.dataset.productId;
  if (productId) {
    loadProductRecommendations(productId);
  }
}

